<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BwnQkC/tc-custom/9781615954742.jpg?1731166637923" alt="This image is the cover for the book Poisoned Ground, Rachel Goddard Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poisoned Ground, Rachel Goddard Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Virginia veterinarian becomes a sleuth when local opponents to a resort development are murdered in this mystery by the author of <i>Bleeding Through</i>.</b></p><p> When a powerful development company sets its sights on Mason Country, Virginia, as the location for a sprawling resort for the rich, the locals begin taking sides. Many residents see the resort as economic salvation for the small Blue Ridge Mountains community, while others fear the county will become financially dependent on a predatory company. </p><p> Few oppose the development more vocally than veterinarian Rachel Goddard. She sides with locals reluctant to sell their land and, in the process, complicates the life of her new husband, Sheriff Tom Bridger. </p><p> When a beloved couple is gunned down on the very farm they refused to sell, it seems supporters will stop at nothing to ensure the success of the resort. Now disagreement in the community has exploded into civil war with both sides lashing out. As the violence escalates, Rachel discovers the attacks are more sinister than they appear. Can she bring the truth to light before her community tears itself apart? </p><p><b>Praise for <i>Poisoned Ground</i></b></p><p><b>“A fast-paced plot with plenty of false leads keeps the reader turning the pages.” —<i>Publishers Weekly</i></b></p><p><b>“Rachel is a likable amateur sleuth who displays genuine affection for her neighbors and the animals she treats. Readers will enjoy seeing series regulars appear throughout the story and appreciate a peek at how Rachel and Tom are getting along as newlyweds. A satisfying series addition.” —<i>Booklist</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Parshall
      </h2>
      
      <p class="authorDescription body article"><P>Sandra Parshall grew up in South Carolina and has worked as a reporter on newspapers in South Carolina, West Virginia, and Baltimore. She lives in Northern Virginia with her husband, a long-time Washington journalist, and three cats.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c7291382